import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../config";
import { cacheDataForInSeconds } from "../constants";
import baseQueryWithCorrelationId from "../services/baseQueryWithCorrelationId";

const enterpriseInformationApiSlice = createApi({
    reducerPath: "enterpriseInformationApi",
    keepUnusedDataFor: cacheDataForInSeconds ?? 300,
    refetchOnMountOrArgChange: cacheDataForInSeconds ?? 300,
    baseQuery: baseQueryWithCorrelationId(config.REACT_APP_ENTERPRISE_INFO_API_URL),
    endpoints: () => ({}),
});

export default enterpriseInformationApiSlice;
